import FormElementRelationMixin from '../mixins/FormElementRelationMixin.js';

Vue.asyncComponent('ak-relation', {
    mixins: [FormElementRelationMixin],
    props: {
        enableForeignList: {
            type: Boolean,
            default: true
        },
        showEdit: {
            type: Boolean,
            default: false,
        },
        baseUri: {
            type: String,
            required: false,
            default: ''
        },
    },
    data() {
        return {
            deleteDialog: false,
            deleteDialogItemId: null,
        }
    },
    watch: {
        currentRelation: {
            deep: true,
            handler() {
                this.setCurrentValue(this.currentRelation.selected);
            }
        },
        value(newValue, oldValue) {
            if(! this.$deepEqual(newValue,oldValue)) {
                this.currentRelation.selected = newValue;
            }
        },
    },
    methods: {
        /**
         *
         * @returns {{name: string, params: {}}}
         */
        relationUrl(editItemId) {
            let params = {};
            params = Object.assign(params, this.$route.params);

            let currentRelationAddon = this.id + ':grid:' + this.currentRelation.foreignList.bundle + ':' + this.currentRelation.foreignList.id;

            // if foreignList is disabled show the form imidiatly and add the dataObject to the selection on save
            if(! this.enableForeignList || editItemId) {
                currentRelationAddon = this.getFormRelationUrl(editItemId);
            }

            if(params.relationString != undefined) {
                params.relationString += ':' + currentRelationAddon;
            } else {
                params.relationString = currentRelationAddon;
            }


            return {
                name: this.$route.name,
                params: params,
                // filter out the filter from query when are on the design settings page
                query: this.$route.name === 'blueprint-skin-settings'
                    ? this.queryWithoutFilters()
                    : this.$route.query
            };
        },
        getFormRelationUrl(objectId = 'new') {
            return this.id + ':form:' + this.currentRelation.foreignList.bundle + ':form:' + objectId;
        },
        editSelectedUrl(selectedItemId) {
            return this.$router.resolve(this.relationUrl(selectedItemId)).href;
        },
        /**
         *
         * @param widget
         * @param widgetKey
         * @param item
         * @returns {*}
         */
        addOnWidgetAttributes(widget, widgetKey, item) {
            // if we have a form control we check if we need to set a value
            let out = { ...widget.formControl, ...widget.attributes, id: widget.id, baseUri: this.baseUri };

            // if we hava a value add it
            if(!out.value && item.addOnValues[widgetKey]) {
                out.value = item.addOnValues[widgetKey];
            }

            return out;
        },
        /**
         *
         * @param id
         */
        openDeleteDialog(id) {
            this.deleteDialog = true;
            this.deleteDialogItemId = id;
        },
        /**
         *
         * @param widgetKey
         * @param item
         * @param value
         */
        handleWidgetInput( widgetKey, item, value) {
            if(!value) return;

            // we can't just set the addOnValues like addOnValues[widgetKey] = value beceause with a new item vue wil not pickup on these changes
            let currentSelection = this.currentRelation.selected.find(selectedItem => selectedItem.id == item.id);
            let addOnValues = {...currentSelection.addOnValues};

            addOnValues[widgetKey] = value;
            currentSelection.addOnValues = addOnValues;
        },
        /**
         *
         * @param id
         * @param values
         */
        async validateAddOnValue(id, values, item) {
            if (!id) return;
            const path = `/${this.bundleId}/${this.definitionId}/validate-add-on`;

            const validateData = {
                "addOnId": id,
                "addOnValues": { ...values },
                "formBundleId": this.$route ? this.$route.params.bundle : null,
                "formDefinitionId": this.$route ? this.$route.params.definition : null,
            };

            try {
                const result = await this.$post(path, validateData);
                let widget = this.relation.widgets.addOns.find(item => item.id == id);
                widget.formControl = { ...widget.formControl, ...result[id] };

                // Do something
            } catch (error) {
                console.log(error);
            }
        },
        /**
         *
         * @param selected
         */
        setCurrentValue(selected) {
            let out = [];
            
            selected.forEach(item => {
                const outItem = {
                    id: item.id,
                    addOnValues: item.addOnValues,
                }

                if(item.entry) {
                    outItem.entry = item.entry;
                }

                if(item.widget) {
                    outItem.widget = item.widget;
                }

                out.push(outItem);
            });

            this.currentValue = out;
        },
        formatStateOutput(e) {
            // if we have no value return it
            if(! e) {
                return e;
            }

            // check if we can have multiple values or not
            if (! this.relation.enableMultiple) {
                // if we can only have one value return the first id;
                return Array.isArray(e) && e[0] ?
                        e[0].id :
                        e;
            } else {
                return e.map(value => value.id);
            }
        },
        /**
         * Trigger close
         */
        triggerClose() {
            let leftOverRelationString = this.$route.params.relationString.substring(0, this.$route.params.relationString.indexOf(this.relationString))

            // if there is still a left over relation string it probably wil end with : this we will need to strip.
            // If this was the first part of a relation string it will not end on : so then this will be skipped
            if (leftOverRelationString.endsWith(':')) {
                leftOverRelationString = leftOverRelationString.substring(0, leftOverRelationString.length - 1)
            }

            this.$router.push({
                ...this.$route,
                params: {
                    ...this.$route.params,
                    relationString: leftOverRelationString ? leftOverRelationString : null
                }
            });
        },
        /**
         * Get the query without filters
         * @return {*|boolean}
         */
        queryWithoutFilters() {
            let query = this.$cloneDeep(this.$route.query);
            const regex = new RegExp("f[0-9]+|v[0-9]+\[[0-9]+\]");

            Object.keys(query).forEach(key => {
                // Check if the query contains any param like: f0, v0[0]n v0[1]....
                if (regex.test(key)) {
                    delete query[key];
                }
            });
            
            return query;
        }
    }
}, 'form/controls/ak-relation.html');
